import React, { Component } from 'react';
import { css, StyleSheet } from 'aphrodite';

import { Flexbox } from './Styles';

import CostComponent from './CostComponent';

import Locale from './models/Locale';

const styles = StyleSheet.create({
  container: {
    marginBottom: 10
  }
});

class Cost extends Component {
  render() {
    return(
      <div className={css(styles.container, Flexbox.row, Flexbox.axisCenter, Flexbox.crossCenter)}>
        <CostComponent value={this.props.cost.c} prefix="$" label={Locale.localized("Cost")}/>
        <CostComponent value={this.props.cost.p} label={Locale.localized("Preparedness")}/>
        <CostComponent value={this.props.cost.q} label={Locale.localized("Quality of Life")}/>
      </div>
    );
  }
}

export default Cost;



// WEBPACK FOOTER //
// ./src/Cost.js